(function ($, Drupal, drupalSettings, once) {
  // Automatically load more post 5 times, then display the load more button.
  Drupal.behaviors.autoLoadMore = {
    count: 0,
    attach: (context, settings) => {
      let loadMoreBtn = $(context).find(".btn-post-load-more");
      if (loadMoreBtn.length) {
        $(once("autoLoadMoreIncrementCount", loadMoreBtn )).on("click", () => {
          Drupal.behaviors.autoLoadMore.count += 1;
        });

        const loadMoreScroll = Drupal.debounce(() => {
          const btnDocumentY = loadMoreBtn.offset().top;
          const bottomWindowY = $(document).scrollTop() + $(window).height();

          if (btnDocumentY - bottomWindowY <= 600) {
            $(once("autoLoadMoreClick", loadMoreBtn)).trigger("click");
          }
        });

        if (Drupal.behaviors.autoLoadMore.count < 4) {
          if (once("autoLoadMoreResize", 'html'))
            $(window).on("resize scroll", loadMoreScroll());
        } else {
          $(once("autoLoadMoreDisplayBtn", loadMoreBtn)).removeClass("hidden");
        }
      }
      $('form:not(".quicksearch-form")').submit(function () {
        $('#waiting').show();
        $(this).children('input[type=submit]').prop('disabled', true);
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
